__turbopack_context__.v({
  "modalContent": "FolderRenameModal-module__dGs7AW__modalContent",
});
